import { useCallback } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import AuthenticationTwoFactorPhoneNumberForm from "./TwoFactor/AuthenticationTwoFactorPhoneNumberForm";

import { enrollTwoFactorPhone } from "../../mutations/EnrollTwoFactorPhoneMutation";

// First SMS two-factor step for users without a verified phone: collect and submit a
// number, which sends the confirmation code and hands off to the challenge step.
const AuthenticationTwoFactorEnrollment = ({ onEnrolled }) => {
  const t = useFormatMessage();
  const helpMessage = t(intlMessages.help);

  const submitPhoneNumber = useCallback(async formState => {
    const { enrollTwoFactorPhone: result } = await enrollTwoFactorPhone(formState);

    return result;
  }, []);

  return (
    <AuthenticationTwoFactorPhoneNumberForm
      submitPhoneNumber={submitPhoneNumber}
      onNumberValidated={onEnrolled}
      helpMessage={helpMessage}
    />
  );
};

export default AuthenticationTwoFactorEnrollment;

const intlMessages = defineMessages({
  title: {
    id: "authentication.twoFactor.enroll.title",
    defaultMessage: "Sécurisation de votre compte"
  },
  help: {
    id: "authentication.twoFactor.enroll.help",
    defaultMessage:
      "Renseignez votre numéro de téléphone mobile pour recevoir un code de " +
      "vérification par SMS à chaque connexion."
  },
  phone: {
    id: "authentication.twoFactor.enroll.phone",
    defaultMessage: "Numéro de téléphone mobile"
  },
  submit: {
    id: "authentication.twoFactor.enroll.submit",
    defaultMessage: "Recevoir le code par SMS"
  }
});
